import React, { useState } from 'react';
import { Input } from 'antd';

// 展示美元、存储分（cents，integer）——表单值直接对应接口的 *Cents 字段
// max 为存储值（分）的上限，默认 int32 最大值 2147483647，避免后端整型溢出
export default function MoneyInput({
    value,
    onChange,
    placeholder,
    max = 2147483647,
}: {
    value?: number;
    onChange?: (v: number | undefined) => void;
    placeholder?: string;
    max?: number;
}) {
    const [text, setText] = useState('');
    const [focused, setFocused] = useState(false);

    const formatted = value == null ? '' : `$${(value / 100).toLocaleString('en-US')}`;
    const display = focused ? text : formatted;

    return (
        <Input
            size="large"
            placeholder={placeholder}
            value={display}
            onFocus={() => {
                setFocused(true);
                setText(value == null ? '' : String(value / 100));
            }}
            onBlur={() => setFocused(false)}
            onChange={(e) => {
                const raw = e.target.value;
                const num = Number(raw.replace(/[^0-9.]/g, ''));
                let cents = raw.trim() !== '' && Number.isFinite(num) ? Math.round(num * 100) : undefined;
                // 超过上限则钳制到 max，并同步回填输入框展示的美元数
                if (cents != null && cents > max) {
                    cents = max;
                    setText(String(max / 100));
                } else {
                    setText(raw);
                }
                onChange?.(cents);
            }}
        />
    );
}
